import React from 'react';
import { cn } from '@/lib/utils';

const statusConfig = {
  'in-queue': {
    label: 'In Queue',
    color: '#78716C',
    bgColor: 'rgba(120, 113, 108, 0.08)',
    borderColor: 'rgba(120, 113, 108, 0.20)'
  },
  'waiting': {
    label: 'Waiting',
    color: '#3D5A80',
    bgColor: 'rgba(61, 90, 128, 0.08)',
    borderColor: 'rgba(61, 90, 128, 0.20)'
  },
  'next-in-line': {
    label: 'Next in Line',
    color: '#D4784A',
    bgColor: 'rgba(212, 120, 74, 0.08)',
    borderColor: 'rgba(212, 120, 74, 0.20)'
  },
  'in-consultation': {
    label: 'In Consultation',
    color: '#3D5A80',
    bgColor: 'rgba(61, 90, 128, 0.08)',
    borderColor: 'rgba(61, 90, 128, 0.20)',
    pulse: true
  },
  'payment-pending': {
    label: 'Payment Pending',
    color: '#F59E0B',
    bgColor: 'rgba(245, 158, 11, 0.08)',
    borderColor: 'rgba(245, 158, 11, 0.20)'
  },
  'completed': {
    label: 'Completed',
    color: '#10B981',
    bgColor: 'rgba(16, 185, 129, 0.08)',
    borderColor: 'rgba(16, 185, 129, 0.20)'
  },
  'no-show': {
    label: 'No Show',
    color: '#EF4444',
    bgColor: 'rgba(239, 68, 68, 0.08)',
    borderColor: 'rgba(239, 68, 68, 0.20)'
  }
};

const StatusPill = ({ status, className, ...props }) => {
  const config = statusConfig[status] || statusConfig['in-queue'];

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1.5',
        'rounded-[var(--radius-full)]',
        'font-["Sora"] text-xs font-semibold',
        className
      )}
      style={{
        backgroundColor: config.bgColor,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: config.borderColor,
        color: config.color
      }}
      data-testid={props['data-testid']}
    >
      <span
        className={cn(
          'w-1.5 h-1.5 rounded-full',
          config.pulse && 'animate-pulse'
        )}
        style={{ backgroundColor: config.color }}
      />
      <span>{config.label}</span>
    </div>
  );
};

StatusPill.displayName = 'StatusPill';

export { StatusPill };